import { render } from "./UserForm.vue?vue&type=template&id=19e7ed63&ts=true"
import script from "./UserForm.ts?vue&type=script&lang=ts"
export * from "./UserForm.ts?vue&type=script&lang=ts"

import "./UserForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__